import { render, staticRenderFns } from "./EPromoterComments.vue?vue&type=template&id=2c9a1cba&scoped=true&"
import script from "./EPromoterComments.vue?vue&type=script&lang=js&"
export * from "./EPromoterComments.vue?vue&type=script&lang=js&"
import style0 from "./EPromoterComments.vue?vue&type=style&index=0&id=2c9a1cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a1cba",
  null
  
)

export default component.exports